export const NEW_REPORT_INTERNAL_STATUS = {
  DATA_LOAD_PENDING: 'DATA_LOAD_PENDING',
  FILE_UPLOAD_DONE: 'FILE_UPLOAD_DONE',
  COMPENSATION_DONE: 'COMPENSATION_DONE',
  DEMOGRAPHICS_DONE: 'DEMOGRAPHICS_DONE',
  GROUPS: 'GROUPS',
  PAY_FACTORS: 'PAY_FACTORS',
  DATA_VALIDATION: 'DATA_VALIDATION',
  REVIEW_AND_RUN: 'REVIEW_AND_RUN',
};

export const REPORT_STATUS_CHECKING_TIME = 5000;
export const REPORT_LIST_UPDATE_TIME = 10000;

export type StatusInfo = { key: string; label: string };

export const STATUS_INFO: Record<string, StatusInfo> = {
  INPROGRESS: { key: 'pe.db.download.INPROGRESS', label: 'Download in Progress' },
  PROCESSING: { key: 'pe.db.download.INPROGRESS', label: 'Download in Progress' },
  FINALIZING: { key: 'pe.db.download.INPROGRESS', label: 'Download in Progress' },
  COMPLETED: { key: 'pe.db.download.COMPLETED', label: 'Download Available' },
  DONE: { key: 'pe.db.download.COMPLETED', label: 'Download Available' },
  FAILED: { key: 'pe.db.download.FAILED', label: 'Download Failed, Try Again' },
  PENDING: { key: 'pe.db.download.PENDING', label: 'Pending' },
  PARTIAL: { key: 'pe.db.download.PARTIAL', label: 'Partial' },
  ERROR: { key: 'pe.db.ERROR', label: 'Error' },
  SUBMIT: { key: 'pe.submit', label: 'Submit' },
};

export const STATUS_CLASS_NAMES: Record<string, string> = {
  INPROGRESS: 'bg-[#B5E1E6] text-[#243D42]',
  PROCESSING: 'bg-[#B5E1E6] text-[#243D42]',
  FINALIZING: 'bg-[#B5E1E6] text-[#243D42]',
  COMPLETED: 'bg-[#B1E7A0] text-[#243D42]',
  FAILED: 'bg-[#FFC1A9] text-[#243D42]',
  ERROR: 'bg-[#FFC1A9] text-[#243D42]',
  DONE: 'bg-[#B1E7A0] text-[#243D42]',
};

export const DATA_UPLOAD_OPTIONS = {
  UPLOAD_NEW: 'uploadNewData',
  UPLOAD_EXISTING: 'uploadExistingData',
};
